import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3671_7377)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3671_7377",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M24 0H0V24H24V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3671_7377)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22.2234 0H1.77187C0.792187 0 0 0.773437 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773437 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43437C4.19531 7.43437 3.27187 6.51094 3.27187 5.37187C3.27187 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50624 6.47813 7.43437 5.33906 7.43437ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5563 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.789V20.4516H9.35626V8.99531H12.7687V10.5609H12.8156C13.289 9.66094 14.4516 8.70937 16.1813 8.70937C19.786 8.70937 20.4516 11.0813 20.4516 14.1656V20.4516Z",
				fill: "#0A0A0A"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3671_7377",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgLinkedin;
